import { useCallback } from "react";
import {
  SimpleForm,
  FileInput,
  FileField,
  useUpdate,
  useNotify,
  useRefresh,
  useRecordContext,
  required,
  Button,
  useListContext,
} from "react-admin";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

interface BillingDialogProps {
  open: boolean;
  onClose: () => void;
  hasNfe: boolean;
  successMessage: string;
  errorMessage: string;
  title: string
}

const BillingDialog = ({ open, onClose, hasNfe = false, title, successMessage, errorMessage }: BillingDialogProps) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const { resource } = useListContext();
  const [update, { isLoading }] = useUpdate();

  if (!record) return null;

  const handleSubmit = (values: { pdfFile?: File, nfeFile?: File }) => {
    update(
      resource,
      {
        id: record.id,
        data: {
          status: "paid",
          pdfFile: values.pdfFile,
          ...(hasNfe ? { nfeFile: values.nfeFile } : {}),
        },
        previousData: record,
      },
      {
        onSuccess: () => {
          notify(successMessage);
          refresh();
          onClose();
        },
        onError: (error) => {
          notify(error?.message || errorMessage, { type: "warning" });
          onClose();
        },
      }
    );
  };

  const handleClick = useCallback(e => {
    e.stopPropagation();
  }, []);

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      onClick={handleClick}
      sx={{ minWidth: 400 }}
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <SimpleForm onSubmit={handleSubmit} toolbar={false}>
          <FileInput
            label="Comprovante de pagamento"
            source="pdfFile"
            accept="application/pdf"
          >
            <FileField source="src" title="title" />
          </FileInput>
          {hasNfe && (
            <FileInput
              label="Nota Fiscal de Serviço"
              source="nfeFile"
              accept="application/pdf"
            >
              <FileField source="src" title="title" />
            </FileInput>
          )}
          <DialogActions sx={{ justifyContent: "space-between", width: '100%' }}>
            <Button
              type="submit"
              label="ra.action.confirm"
              variant="contained"
              disabled={isLoading}
            />
            <Button
              label="ra.action.cancel"
              variant="outlined"
              onClick={onClose}
              disabled={isLoading}
            />
          </DialogActions>
        </SimpleForm>
      </DialogContent>
    </Dialog>
  );
};

export default BillingDialog;
